// api/auth.js
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = import.meta.env.VITE_API_URL_AUTH;

export const login = async (username, password) => {
  try {
    const response = await axios.post(
      `${API_URL}/sign-in/v1`,
      { user_name: username, password },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const refreshTokenAPI = async (token, userType) => {
  try {
    const response = await axios.post(
      `${API_URL}/admin-session/v1`,
      { refresh_token: token, user_type: userType },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error("Invalid username or password");
  }
};

export const resetPassword = async (data, token) => {
  try {
    const response = await axios.post(`${API_URL}/reset-password/v1`, data, {
      headers: {
        Authorization: `Bearer ${token}`, // Ensure to replace `{token}` with the actual token value
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    toast.error(error?.response?.data?.message);
    throw new Error("Invalid Token");
  }
};

export const verifyAdUser = async (data, token) => {
  try {
    const response = await axios.post(`${API_URL}/verify-ad-user/v1`, data, {
      headers: {
        Authorization: `Bearer ${token}`, // Ensure to replace `{token}` with the actual token value
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const logoutAPI = async (userType, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/admin-logout/v1`,
      { user_type: userType },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Ensure to replace `{token}` with the actual token value
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error("Invalid username or password");
  }
};
